import { generateTestId } from "@client-shared";

export const setBatchesTableTestId = (identifier: string): string =>
  generateTestId("BatchesTable", identifier);

// Specific testId setters for tests
export const setBatchesTableContainerTestId = (): string =>
  setBatchesTableTestId("container");
export const setBatchesTableHeaderTestId = (column: string): string =>
  setBatchesTableTestId(`header-${column}`);
export const setBatchesTableRowTestId = (id: string): string =>
  setBatchesTableTestId(`row-${id}`);
export const setBatchesTableStatusTestId = (status: string): string =>
  setBatchesTableTestId(`status-${status}`);
